import { BellOutlined } from '@ant-design/icons';
import { Badge, Modal } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../style/Notifications.module.scss';
import { StoreContext } from '../../../store/store';
import MikeNotificationGroups from '../../Home/Component/Notifications/MikeNotificationGroups';
import { renderNotificationTitle } from '../../Home/Component/Notifications/renders';

type PrivateProps = {
  children?: React.ReactNode;
};

export default function Notifications({ children }: PrivateProps) {
  const [showNotificationsDot, setShowNotificationsDot] = useState(false);

  const { notifications, showNotifications, setShowNotifications } =
    useContext(StoreContext);

  useEffect(() => {
    setShowNotificationsDot(
      notifications && notifications.length > 0 ? true : false
    );
  }, [notifications]);

  function openNotifications() {
    setShowNotificationsDot(false);
    setShowNotifications(true);
  }

  function handleCloseNotifcations() {
    setShowNotifications(false);
  }

  const notificationsContent = (
    <div>
      <MikeNotificationGroups
        notifications={notifications}
        renderTitle={renderNotificationTitle}
      />{' '}
    </div>
  );

  return (
    <>
      <Badge
        dot={showNotificationsDot}
        className={styles.cartBadge}
        offset={[-4, 10]}
      >
        <BellOutlined onClick={openNotifications} className={styles.cartIcon} />
      </Badge>
      <Modal
        visible={showNotifications}
        footer={null}
        onCancel={handleCloseNotifcations} // 'calc(100vh - 400px)' notifications && notifications.length > 2 ? {height: '50vh' } : {}
        className={styles.notificationDialog}
        // style={notifications && notifications.length > 0 ? {height: '50vh' } : {}}
        bodyStyle={{ overflowY: 'scroll' }}
      >
        {notificationsContent}
      </Modal>
    </>
  );
}
